import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'

import API from '@/lib/api'

export function useAdminUserImpersonation() {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'admin.users',
  })
  const [impersonatingUserId, setImpersonatingUserId] = useState<number | null>(null)

  const impersonate = (userId: number) => {
    setImpersonatingUserId(userId)

    API.post(`/api/v2/admin/users/${userId}/impersonate`)
      .then(() => {
        window.location.href = '/'
      })
      .catch(() => {
        toast.error(t('list.actions.impersonateError'))
        setImpersonatingUserId(null)
      })
  }

  return {
    impersonate,
    impersonatingUserId,
    isImpersonating: impersonatingUserId !== null,
  }
}
